export const WEB_VERSION = {
  V1: 1,
  V2: 2,
} as const;

export type WebVersion = (typeof WEB_VERSION)[keyof typeof WEB_VERSION];
